<div class="dialog dialog-small dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">Student Loan Repayment Benefit</h4>
    <div class="dialog-inner">The Student Loan Protection benefit covers student loan payments for insured individuals
        with an advanced degree while they are disabled. The insured must be totally or partially
        disabled for at least 180 days, and loans must have been incurred before disability.

        Payments are paid directly to the lending institution, and covers the lesser of: the actual student loan payment
        due, OR the maximum
        monthly benefit specified in the policy.
    </div>
    <div class="dialog-inner semibold">Additional Annual Cost</div>
   <div class="cost">{{cost ? (cost | currency) : 'Calculating...'}}</div>
    <!--
    <br />
    <mat-label class="label-text">Monthly Contribution Amount</mat-label>
    -->
    <br />
    <mat-form-field>
        <mat-label class="label-text">Monthly Amount</mat-label>
        <mat-select [(ngModel)]="SLRAmount" [disabled]="SLRAmountOptions.length <= 1" (selectionChange)="updateCost()">
            <mat-option *ngIf="SLRAmountOptions.length <= 1" value="{{SLRAmount}}">${{SLRAmount}}</mat-option>
            @for ( item of SLRAmountOptions; track item ) {
            <mat-option value="{{item}}">${{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <!--
    <br />    
    <mat-label class="label-text">Maximum Benefit Duration</mat-label>
    -->
    <br />
    <mat-form-field>
        <mat-label class="label-text">Maximum Benefit Duration</mat-label>
        <mat-select [(ngModel)]="SLRDuration" [disabled]="SLRDurationOptions.length <= 1"
            (selectionChange)="updateCost()">
            <mat-option *ngIf="SLRDurationOptions.length <= 1" value="{{SLRDuration}}">${{SLRDuration}}</mat-option>
            @for ( item of SLRDurationOptions; track item ) {
            <mat-option value="{{item}}">{{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <!--<div class="dialog-inner">Would you like to add this benefit to your policy?</div> -->
    <div *ngIf="!inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="no()" class="chat-button chat-button-define" mat-flat-button>Cancel</button>
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Add to Policy</button>

    </div>
    <div *ngIf="inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Close</button>
    </div>
    <br/>